export default "__VITE_ASSET__5lupsbMU__"